import { StartingCondition } from '../enums';

export const DEFAULT_STARTING_CONDITION = StartingCondition.Cold;
